import vue from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import User from '../../../interfaces/User';
import Auth from '../../../interfaces/Auth';

@Component({
  template: require('./reset-password-page.html'),
})
export class ResetPasswordPage extends vue {
  email = '';
  error = '';

  auth = IocContainer.get < Auth > (SERVICES.AUTH);

  mounted() {
    if (this.auth.isAuthenticated()) {
      this.$router.push({ name: 'course' });
    }
  }

  resetPassword() {
    this.error ='';
    this.auth.resetPassword(this.email).then(
      (response) => {
        this.error = response.data.message;
      },
      (error) => {
        this.errorReport(error);
      },
    );
  }

  errorReport(error) {
    this.error = error.response.data.message;
  }
}